import backbone from "backbone";
import $ from "jquery";
import _ from "underscore";

let CustomBasket = Backbone.View.extend({
  el: document,

  events: {},

  initialize: function () {
    this.membershipContainer = document.querySelector(
      `[data-membership-upsale-block]`
    );

    // Bail.
    if (!this.membershipContainer) {
      return;
    }

    this.membershipThankYou = document.querySelector(
      "[data-membership-thankyou-container]"
    );

    this.api = ajax_client.spektrix_api_url;

    this.autoRenewBoxes = document.querySelectorAll(`input[name="autorenew"]`);

    this.membershipComponents =
      document.querySelectorAll(`spektrix-memberships`);

    // Bind methods.
    window.addEventListener("message", this.receiveMessage.bind(this), false);
    this.setAutoRenew =  this.setAutoRenew.bind(this);

    this.processCustomBasket = this.processCustomBasket.bind(this);
    this.request = this.request.bind(this);

    this.handleAutoRenew();

    this.render();
  },

  receiveMessage(e) {
    if (e.data.length && e.data.includes("basketContents")) {
      this.processCustomBasket();
    }
  },

  handleAutoRenew() {
    const spektrixComponents = [...this.membershipComponents];

    this.autoRenewBoxes?.forEach((checkbox) => {
      checkbox.addEventListener("change", (e) => {
        let whichMemberships = checkbox.dataset.membershipIds?.split(",");

        if (checkbox.checked) {
          this.setAutoRenew(spektrixComponents, whichMemberships, true);
        } else {
          this.setAutoRenew(spektrixComponents, whichMemberships, false);
        }
      });

    });
  },

  setAutoRenew(spektrixComponents, membershipIDs, value) {
    membershipIDs?.forEach((membershipID) => {
      const foundMembership = spektrixComponents?.filter((component) => {
        return (
          String(membershipID).trim() === String(component.membershipId).trim()
        );
      });

      foundMembership?.forEach((item) => {
        if (typeof item.setAttribute === "function") {
          item.setAttribute("auto-renew", value);
        }
      });

    });
  },

  async processCustomBasket() {
    try {
      this.basket = await this.getBasket();

      let memberShipAdded = this.basket.membershipSubscriptions.length > 0;

      console.log(
        "Membership subscriptions added",
        this.basket.membershipSubscriptions
      );

      if (!this.basket.customer) {
        // Non logged in - membership added
        if (memberShipAdded) {
          this.membershipThankYou.style.display = "";
          this.membershipContainer.style.display = "none";
        } else {
          this.membershipContainer.style.display = "";
          this.membershipThankYou.style.display = "none";
        }
      } else {
        // Logged in user.
        let hasMembership = await this.customerHasMembership();

        console.log("Check customer has membership ", hasMembership);

        if (hasMembership) {
          // Don't show anything for a logged-in customer who has a membership.
          this.membershipContainer.style.display = "none";
          this.membershipThankYou.style.display = "none";

          if (this.giftBlockFormMembers && !this.giftVoucherContainer) {
            this.customBasketContainer.append(this.giftBlockFormMembers);
          }
        } else {
          this.membershipContainer.style.display = memberShipAdded
            ? "none"
            : "";
          this.membershipThankYou.style.display = memberShipAdded ? "" : "none";
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  },

  async customerHasMembership() {
    let customer = await this.getCustomerData();

    if (customer.subscriptions.length) {
      return customer.subscriptions[0].membership.id ? true : false;
    } else {
      return false;
    }
  },

  async getCustomerData() {
    let response = await this.request("/customer?$expand=1", "GET");

    return response;
  },

  async getBasket() {
    let response = await this.request("/basket?$expand=1", "GET");

    return response;
  },

  async request(resource, verb, data) {
    console.log("API", this.api);

    this.payload = {
      credentials: "include",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
      method: verb,
      body: data ? JSON.stringify(data) : null,
    };

    return fetch(this.api + resource, this.payload)
      .then(function (response) {
        if (response.status != 204) return response.json();
      })
      .catch((error) => {
        console.log("Error:", error);
      });
  },

  reloadIframe() {
    return new Promise((resolve) => {
      const iframe = document.getElementById("SpektrixIFrame");

      if (iframe) {
        iframe.addEventListener("load", function onLoad() {
          iframe.removeEventListener("load", onLoad);
          resolve(true);
        });

        iframe.src = iframe.src;
      } else {
        resolve(false);
      }
    });
  },
});

export default CustomBasket;
